<template>
  <el-dialog
      title="Просмотр изображений"
      :visible="visible"
      :before-close="close"
      width="80%"
      :close-on-press-escape="false"
  >

    <div v-if="photos.length" class="gallery">
      <div v-for="photo of photos" :key="photo.id" class="gallery__item">
        <image-copper :image="photo"/>
      </div>
    </div>
    <el-alert
        v-else
        :closable="false"
        title="Изображения не найдены"
        style="margin-top: 10px"
        type="info">
    </el-alert>

  </el-dialog>
</template>

<script>
import ImageCopper from "@/components/imageCopper/ImageCopper.vue"

export default {
  name: "ViewImages",
  data() {
    return {
      error: null,
    };
  },
  props: {
    devices: {
      required: true,
    },
    visible: {
      required: true,
    }
  },
  computed: {
    photos() {
      if(!this.devices) return
      let files = []
      this.devices.forEach(device => {
        device.diagnostic_field.forEach(field => {

          if (field.value)
            field.value.file.forEach(file => {

              if (this.isImage(file.ext)) {
                file.field = field.title
                files.push(file)
              }
            })

        })
      })

      return files
    }
  },
  components: {ImageCopper},
  methods: {
    isImage(type) {
      return type === "jpeg" || type === "jpg" || type === "png";
    },
    close() {
      this.$emit('close')
    },

  }
};
</script>

<style scoped lang="scss">
.gallery {
  width: 100%;

  display: grid;
  grid-template-columns: repeat(6, 1fr);
  grid-gap: 10px;
  grid-auto-flow: dense;

  &__item:nth-child(5n-4), &__item:nth-child(5n-3), &__item:nth-child(5n-2) {
    border: 1px solid #e7e7e7;
    border-radius: 4px;
    grid-column: span 2;
    height: 252px;
  }

  &__item:nth-child(5n), &__item:nth-child(5n-1) {
    grid-column: span 3;
    grid-row: span 1;
    border: 1px solid #e7e7e7;
    border-radius: 4px;
    height: 386px;
  }

}
</style>